import { Team as TeamModule } from "../modules/Team/Team";

const Team = () => {
  return <TeamModule />;
};

export default Team;
